import React from 'react';
import PaymentCardInfo from '../PaymentCardInfo/PaymentCardInfo';

function PaymentCardInfoItem(props) {
    return <div className="payment-card-info-item">
        <PaymentCardInfo  {...props} />
    </div>;
}

export default PaymentCardInfoItem;